import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AutoTabProvider } from "react-auto-tab";
import { ThailandAddressTypeahead, ThailandAddressValue } from "react-thailand-address-typeahead";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllSupplierInformation } from "../../redux/handlers/logic/getAllSupplierInformation.handler";
import { defaultOption } from "constants/ui/options";
import { getAllGroupOfSupplier } from "../../redux/handlers/logic/getAllGroupOfSupplier.handler";
import { getSupplierBranch, getSupplierFullName, getSupplierMainContactFullName, mapMstToOptions } from "utils/HelperFunction";
import { getFullUrlPath } from "utils/HandleFileFunction";
import { clearUpdateGroupOfSupplier, updateGroupOfSupplier } from "../../redux/handlers/logic/updateGroupOfSupplier.handler";
import { clearCreateGroupOfSupplier, createGroupOfSupplier } from "../../redux/handlers/logic/createGroupOfSupplier.handler";
export function Distributor() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionsDistributorgroup = _useState1[0], setOptionsDistributorgroup = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), optionsGroupOfSuplier = _useState2[0], setOptionsGroupOfSuplier = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), selectedGroupOfSuplierID = _useState3[0], setSelectedGroupOfSuplierID = _useState3[1];
    var _useState4 = _sliced_to_array(useState(defaultOption), 2), groupOfSupplier = _useState4[0], setGroupOfSupplier = _useState4[1];
    var _useState5 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), distributorgroup = _useState5[0], setDistributorgroup = _useState5[1];
    var loadAllMsts = function() {
        dispatch(getAllGroupOfSupplier());
    };
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var getAllSupplierInformationReducer = useAppSelector(function(state) {
        return state.getAllSupplierInformationReducer;
    });
    var gettableData = function() {
        dispatch(getAllSupplierInformation({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        loadAllMsts();
        gettableData();
    }, []);
    useEffect(function() {
        setIsLoading(getAllSupplierInformationReducer.isFetching || getAllGroupOfSupplierReducer.isFetching);
        if (getAllSupplierInformationReducer.data) {
            setTabledata(getAllSupplierInformationReducer.data.data);
        }
        if (getAllGroupOfSupplierReducer.data) {
            var options = mapMstToOptions(getAllGroupOfSupplierReducer.data.data);
            setOptionsGroupOfSuplier([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
    }, [
        getAllGroupOfSupplierReducer,
        getAllSupplierInformationReducer
    ]);
    var columns = [
        {
            name: "รหัสผู้จำหน่าย",
            selector: function(row) {
                return row.code;
            },
            width: "170px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/distributor/edit/" + row.id,
                        children: row.code ? row.code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "รูป",
            selector: function(row) {
                return row.img_path;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx("img", {
                        src: row.img_path ? getFullUrlPath(row.img_path) : "",
                        className: "imgprofile"
                    })
                });
            },
            width: "160px",
            center: "true"
        },
        {
            name: "ชื่อผู้จำหน่าย",
            selector: function(row) {
                return getSupplierFullName(row);
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        getSupplierFullName(row),
                        " ",
                        /*#__PURE__*/ _jsx("br", {}),
                        " ",
                        getSupplierBranch(row),
                        " "
                    ]
                });
            }
        },
        {
            name: "ชื่อผู้ติดต่อ",
            selector: function(row) {
                return getSupplierMainContactFullName(row);
            }
        },
        {
            name: "เบอร์โทรผู้ติดต่อ",
            selector: function(row) {
                var _row_main_contact_phone_number;
                return (_row_main_contact_phone_number = row.main_contact_phone_number) !== null && _row_main_contact_phone_number !== void 0 ? _row_main_contact_phone_number : "-";
            }
        },
        // {
        //   name: "เงื่อนไขชำระเงิน",
        //   selector: (row) =>
        //     row.dimMstPaymentMethod ? row.dimMstPaymentMethod.name : "-",
        // },
        // {
        //   name: "ประเภทราคา",
        //   selector: (row) => "-",
        // },
        {
            name: "กลุ่ม",
            selector: function(row) {
                return row.dimGroupOfSupplier ? row.dimGroupOfSupplier.name : "-";
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.is_active;
            },
            center: "true",
            width: "130px",
            cell: function(row, index, column, id) {
                return row.is_active == 1 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: "เปิดใช้งาน"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "90px"
                    },
                    children: "ปิดใช้งาน"
                });
            }
        }
    ];
    var _useState6 = _sliced_to_array(useState(""), 2), filterText = _useState6[0], setFilterText = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), filteredItems = _useState7[0], setFilteredItems = _useState7[1];
    useEffect(function() {
        setFilteredItems(tabledata.filter(function(item) {
            return item.dimGroupOfSupplier && item.dimGroupOfSupplier.code.toLowerCase().includes(filterText.toLowerCase()) || getSupplierFullName(item).toLowerCase().includes(filterText.toLowerCase());
        }));
    }, [
        tabledata,
        filterText
    ]);
    useEffect(function() {
        if (selectedGroupOfSuplierID) {
            setFilteredItems(tabledata.filter(function(item) {
                return item.dimGroupOfSupplier && item.dimGroupOfSupplier.id === selectedGroupOfSuplierID;
            }));
        } else {
            setFilteredItems(tabledata);
        }
    }, [
        selectedGroupOfSuplierID
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดซื้อ"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ผู้จัดจำหน่าย",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ _jsxs(Link, {
                                to: "/distributor",
                                className: "btn-category px-4 text-decoration-none active",
                                children: [
                                    "ผู้จำหน่าย",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Link, {
                                to: "/distributorgroup",
                                className: "btn-category text-decoration-none px-4",
                                children: [
                                    "กลุ่มผู้จัดจำหน่าย",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: filteredItems,
                                    filename: "ผู้จัดจำหน่าย"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-3",
                                    style: {
                                        width: "180px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มผู้จัดจำหน่าย"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setSelectedGroupOfSuplierID(e.value);
                                                    setGroupOfSupplier(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsGroupOfSuplier,
                                                placeholder: "",
                                                value: groupOfSupplier
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อผู้จำหน่าย",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/distributor/create",
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    children: "เพิ่มผู้จัดจำหน่าย"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: true,
                            PerPage: 10
                        })
                    ]
                })
            })
        ]
    });
}
export function DistributorGroup() {
    var formdefault = {
        id: "",
        code: "",
        name: "",
        desc: "",
        is_active: true
    };
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), tabledata = _useState[0], setTabledata = _useState[1];
    var _useState1 = _sliced_to_array(useState(formdefault), 2), formdata = _useState1[0], setFormdata = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), modalcreateShow = _useState2[0], setModalcreateShow = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), modalDeleteShow = _useState3[0], setModalDeleteShow = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccessShow = _useState4[0], setModalsuccessShow = _useState4[1];
    var getAllGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.getAllGroupOfSupplierReducer;
    });
    var gettableData = function() {
        var countSup = true;
        dispatch(getAllGroupOfSupplier(countSup));
    };
    useEffect(function() {
        gettableData();
    }, []);
    useEffect(function() {
        setIsLoading(getAllGroupOfSupplierReducer.isFetching);
        if (getAllGroupOfSupplierReducer.data && !getAllGroupOfSupplierReducer.isError) {
            setTabledata(getAllGroupOfSupplierReducer.data.data);
        }
    }, [
        getAllGroupOfSupplierReducer
    ]);
    var columns = [
        {
            name: "รหัสกลุ่ม",
            selector: function(row) {
                return row.code;
            },
            width: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Button, {
                        className: "btn btn-link me-2",
                        onClick: function() {
                            setModalcreateShow(true);
                            setFormdata(row);
                        },
                        children: row.code
                    })
                });
            }
        },
        {
            name: "ชื่อกลุ่ม",
            selector: function(row) {
                return row.name;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.name,
                        " "
                    ]
                });
            }
        },
        {
            name: "จำนวนผู้จัดจำหน่าย",
            selector: function(row) {
                return row._count && row._count.dimSupplierInformations ? row._count.dimSupplierInformations : 0;
            },
            center: "true"
        },
        {
            name: "คำอธิบาย",
            selector: function(row) {
                return row.desc;
            }
        }
    ];
    var _useState5 = _sliced_to_array(useState(""), 2), filterText = _useState5[0], setFilterText = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), filteredItems = _useState6[0], setFilteredItems = _useState6[1];
    useEffect(function() {
        setFilteredItems(tabledata.filter(function(item) {
            return item.code && item.code.toLowerCase().includes(filterText.toLowerCase()) || item.name && item.name.toLowerCase().includes(filterText.toLowerCase());
        }));
    }, [
        tabledata,
        filterText
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดซื้อ"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ผู้จัดจำหน่าย",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-2",
                        children: [
                            /*#__PURE__*/ _jsxs(Link, {
                                to: "/distributor",
                                className: "btn-category text-decoration-none px-4 ",
                                children: [
                                    "ผู้จำหน่าย",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Link, {
                                to: "/distributorgroup",
                                className: "btn-category text-decoration-none px-4 active",
                                children: [
                                    "กลุ่มผู้จัดจำหน่าย",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: filteredItems,
                                    filename: "ผู้จัดจำหน่าย"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหา",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    onClick: function() {
                                        setModalcreateShow(true);
                                        setFormdata(formdefault);
                                    },
                                    children: "เพิ่มกลุ่มผู้จัดจำหน่าย"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: true,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(DistributorGroupCreateModal, {
                show: modalcreateShow,
                onHide: function() {
                    return setModalcreateShow(false);
                },
                handleDelete: function() {
                    setModalDeleteShow(true);
                    setModalcreateShow(false);
                },
                onSuccess: function() {
                    setModalcreateShow(false);
                    setModalsuccessShow(true);
                },
                formdata: formdata
            }),
            /*#__PURE__*/ _jsx(ConfirmDeleteModal, {
                show: modalDeleteShow,
                onHide: function() {
                    return setModalDeleteShow(false);
                },
                onConfirm: function() {
                    return setModalDeleteShow(false);
                },
                onSuccess: function() {
                    setModalsuccessShow(true);
                },
                formdata: formdata
            }),
            /*#__PURE__*/ _jsx(SuccessDeleteModal, {
                show: modalsuccessShow,
                onHide: function() {
                    return setModalsuccessShow(false);
                }
            })
        ]
    });
}
function DistributorGroupCreateModal(props) {
    var setModalDeleteShow = props.setModalDeleteShow, formdata = props.formdata, handleDelete = props.handleDelete, onSuccess = props.onSuccess, rest = _object_without_properties(props, [
        "setModalDeleteShow",
        "formdata",
        "handleDelete",
        "onSuccess"
    ]);
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var schema = yup.object().shape({
        code: yup.string().required(),
        name: yup.string().required(),
        desc: yup.string().required()
    });
    var createGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.createGroupOfSupplierReducer;
    });
    var updateGroupOfSupplierReducer = useAppSelector(function(state) {
        return state.updateGroupOfSupplierReducer;
    });
    useEffect(function() {
        setIsLoading(createGroupOfSupplierReducer.isFetching);
        if (createGroupOfSupplierReducer.data && !createGroupOfSupplierReducer.isError) {
            var countSup = true;
            dispatch(getAllGroupOfSupplier(countSup));
            dispatch(clearCreateGroupOfSupplier());
            onSuccess();
        }
    }, [
        createGroupOfSupplierReducer
    ]);
    useEffect(function() {
        setIsLoading(updateGroupOfSupplierReducer.isFetching);
        if (updateGroupOfSupplierReducer.data && !updateGroupOfSupplierReducer.isError) {
            var countSup = true;
            dispatch(getAllGroupOfSupplier(countSup));
            dispatch(clearUpdateGroupOfSupplier());
            onSuccess();
        }
    }, [
        updateGroupOfSupplierReducer
    ]);
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsxs(Modal.Body, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex align-items-center px-3 py-2 mb-4 pb-3",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-24 fw-bold me-auto",
                            style: {
                                color: "rgba(76, 78, 100, 0.87)"
                            },
                            children: "จัดการกลุ่มผู้จัดจำหน่าย"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            onClick: props.onHide,
                            className: "btn btn-close-modal"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "px-3",
                    children: /*#__PURE__*/ _jsx(Formik, {
                        enableReinitialize: true,
                        initialValues: formdata,
                        validationSchema: schema,
                        onSubmit: function() {
                            var _ref = _async_to_generator(function(values) {
                                return _ts_generator(this, function(_state) {
                                    if (formdata.id) {
                                        dispatch(updateGroupOfSupplier(formdata.id, values, {
                                            modalObj: modalObj,
                                            setModalObj: setModalObj
                                        }));
                                    } else {
                                        dispatch(createGroupOfSupplier(values, {
                                            modalObj: modalObj,
                                            setModalObj: setModalObj
                                        }));
                                    }
                                    return [
                                        2
                                    ];
                                });
                            // props.onSuccess();
                            });
                            return function(values) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        children: function(param) /*#__PURE__*/ {
                            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                            var _values_code, _values_name, _values_desc;
                            return _jsxs(Form, {
                                noValidate: true,
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-3 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "รหัสกลุ่ม ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "text",
                                                name: "code",
                                                className: "form-control",
                                                placeholder: "กรอกรหัสกลุ่ม",
                                                value: (_values_code = values.code) !== null && _values_code !== void 0 ? _values_code : "",
                                                onChange: handleChange,
                                                isInvalid: !!errors.code
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-3 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "ชื่อกลุ่ม ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "text",
                                                name: "name",
                                                className: "form-control",
                                                placeholder: "กรอกชื่อกลุ่ม",
                                                value: (_values_name = values.name) !== null && _values_name !== void 0 ? _values_name : "",
                                                onChange: handleChange,
                                                isInvalid: !!errors.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-3 form-st-3 pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                className: "mb-1",
                                                children: [
                                                    "คำอธิบาย ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger",
                                                        children: "*"
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                type: "text",
                                                name: "desc",
                                                className: "form-control",
                                                placeholder: "กรอกคำอธิบาย",
                                                value: (_values_desc = values.desc) !== null && _values_desc !== void 0 ? _values_desc : "",
                                                onChange: handleChange,
                                                isInvalid: !!errors.desc
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-2  tc-10",
                                        children: "สถานะ"
                                    }),
                                    [
                                        "radio"
                                    ].map(function(type) {
                                        return /*#__PURE__*/ _jsxs("div", {
                                            className: "mb-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                    inline: true,
                                                    label: "เปิดใช้งาน",
                                                    name: "is_active",
                                                    type: type,
                                                    id: "inline-".concat(type, "-21"),
                                                    className: "form-check-st-2 tc-7",
                                                    checked: values.is_active == true,
                                                    onChange: function(e) {
                                                        setFieldValue("is_active", true);
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                    inline: true,
                                                    label: "ปิดใช้งาน",
                                                    name: "is_active",
                                                    type: type,
                                                    id: "inline-".concat(type, "-22"),
                                                    className: "form-check-st-2 tc-7",
                                                    checked: values.is_active == false,
                                                    onChange: function(e) {
                                                        setFieldValue("is_active", false);
                                                    }
                                                })
                                            ]
                                        }, "inline-".concat(type));
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex align-items-center pt-5 pb-3 btn-group-control",
                                        children: [
                                            values.id ? /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                className: "btn-st-5 me-auto px-4 ",
                                                style: {
                                                    width: "90px"
                                                },
                                                onClick: props.handleDelete,
                                                children: "ลบ"
                                            }) : /*#__PURE__*/ _jsx("div", {
                                                className: "me-auto"
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                type: "button",
                                                className: "btn-st-6 me-3 ",
                                                style: {
                                                    width: "100px"
                                                },
                                                onClick: props.onHide,
                                                children: "ยกเลิก"
                                            }),
                                            /*#__PURE__*/ _jsxs(Button, {
                                                type: "submit",
                                                className: "btn-st-3  ",
                                                style: {
                                                    width: "100px"
                                                },
                                                children: [
                                                    " ",
                                                    values.id ? "แก้ไข" : "บันทึก"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
                })
            ]
        })
    }));
}
function ConfirmDeleteModal(props) {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var handleDelete = function(id) {
        if (id) {
            var payload = {
                is_delete: true
            };
            dispatch(updateGroupOfSupplier(id, payload, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            props.onHide();
            props.onSuccess();
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7 mb-2",
                                    children: "คุณการลบกลุ่มผู้จัดจำหน่าย"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-center fs-22 tc-7",
                                    children: [
                                        " ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "tc-5",
                                            children: props.formdata.name
                                        }),
                                        " ",
                                        "ใช่หรือไม่"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-center pt-4 mt-3  btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 mx-3 ",
                                    style: {
                                        width: "100px"
                                    },
                                    onClick: props.onHide,
                                    children: "ยกเลิก"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-3 mx-3  ",
                                    style: {
                                        width: "100px"
                                    },
                                    onClick: function() {
                                        return handleDelete(props.formdata.id);
                                    },
                                    children: "ยืนยัน"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }));
}
function SuccessDeleteModal(props) {
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-22 tc-7",
                        children: "ทำรายการสำเร็จ"
                    })
                ]
            })
        })
    }));
}
var getdistributorgroup = function() {
    var empty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var options = [];
    fetch("/json/distributorgroup.json").then(function(response) {
        return response.json();
    }).then(function(result) {
        if (empty === true) {
            var obj = {};
            obj["value"] = "";
            obj["label"] = "ทั้งหมด";
            options.push(obj);
        }
        for(var i = 0; i < result.length; i++){
            var obj = {};
            obj["value"] = result[i].distributorgroupID;
            obj["label"] = result[i].name;
            options.push(obj);
        }
    }).catch(function(error) {
        return console.log("error", error);
    });
    return options;
};
